module.exports = __webpack_public_path__ + "img/status-rank.0acb7123.png";